import {
  Stack, Alert, AlertTitle, StackProps,
  Typography
} from "@mui/material"

import { UserRoleChip } from "features/user/components/roleChip"

type ExtendError = Error & {
  response?: {
    data?: {
      code?: number
      message?: string
      needRoles?: string
      errors?: {
        location?: string
        msg?: string
        path?: string
        type?: string
        value?: string
      }[]
    }
  }
}

type ErrorInfoProps = {
  error: ExtendError | null | undefined
} & StackProps
export const ErrorInfo = ({
  error,
  ...others
}: ErrorInfoProps) => error ? (
  <Stack {...others}>
    <Alert severity="error" sx={{ wordBreak: 'break-all' }}>
      <AlertTitle>{error.response?.data?.message ?? error.message}</AlertTitle>
      {error.response?.data?.code === 10 && (
        error.response.data.needRoles ? (
          <>
            <Typography component="p" variant="body2" whiteSpace="pre-wrap">
              必要な権限がありません。下記のいずれかが必要です
            </Typography>
            <Stack direction="row" spacing={1} useFlexGap marginTop={1}>
              {error.response.data.needRoles?.split(',')?.map((role, i) => (
                <UserRoleChip key={`needrole-${i}`} role={role.trim()}/>
              ))}
            </Stack>
          </>
        ) : (
          <Typography component="p" variant="body2" whiteSpace="pre-wrap">
            必要な権限がありません
          </Typography>
        )
      )}
      {error.response?.data?.errors?.map((error, i) =>
        error.type === 'field' ? <p key={`error-detail-${i}`}>{error.path}: {error.msg}</p> : <></>
      )}
    </Alert>
  </Stack>
) : <></>

type ErrorBlockProps = {
  error: ExtendError | ExtendError[] | null | undefined
} & StackProps
export const ErrorBlock = ({
  error,
  ...others
}: ErrorBlockProps) => error ? (
  Array.isArray(error) ? (
    error.length > 0 ? (
      <Stack {...others} direction="column" spacing={1}>
        {error.map((error, i) => <ErrorInfo key={`error-${i}`} error={error}/>)}
      </Stack>
    ) : <></>
  ) : (
    <ErrorInfo {...others} error={error}/>
  )
) : <></>